<template>
  <div>
    <div v-if="$apollo.loading" class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <v-expansion-panels v-else v-model="panel" accordion>
      <v-expansion-panel v-if="firstWillFree">
        <v-expansion-panel-header>
          Your first will is FREE
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <RedeemFirstWillFreeSubscription
            v-if="paymentPlan == 'SUBSCRIPTION'"
          />
          <RedeemFirstWillFreeOnceOff v-else />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="registrationCards.length"
        :disabled="showVoucherPaymentForm || firstWillFree"
      >
        <v-expansion-panel-header> An existing card </v-expansion-panel-header>
        <v-expansion-panel-content>
          <RecurringPayment
            :registration-cards="registrationCards"
            :payment-plan="paymentPlan"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel :disabled="showVoucherPaymentForm || firstWillFree">
        <v-expansion-panel-header> A new bank card </v-expansion-panel-header>
        <v-expansion-panel-content>
          <PaymentForm
            v-show="paymentFormLoaded"
            v-if="!showVoucherPaymentForm"
            :payment-plan="paymentPlan"
            :tokenize-only="false"
            @payment-form-loaded="paymentFormLoaded = true"
          />
          <div v-show="!paymentFormLoaded" class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel :disabled="showVoucherPaymentForm || firstWillFree">
        <v-expansion-panel-header>
          An electronic fund transfer
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <h4 class="mb-1"><u>Bank details</u></h4>
          <p class="mb-1">
            Account name: <b>{{ whitelabel.eftPaymentAccountName }}</b>
          </p>
          <p class="mb-1">
            Account number: <b>{{ whitelabel.eftPaymentAccountNumber }}</b>
          </p>
          <p class="mb-1">
            Bank: <b>{{ whitelabel.eftPaymentBankName }}</b>
          </p>
          <p class="mb-1">
            Amount: <b>R {{ onceOffPrice }}</b>
          </p>
          <p class="mb-1">
            Reference: <b>{{ testator.fullName }}</b>
          </p>
          <p class="mt-4">
            Email your proof of payment to
            <a :href="`mailto:${whitelabel.eftPaymentPopEmail}`">{{
              whitelabel.eftPaymentPopEmail
            }}</a>
            and we will send you a voucher to download your will.
          </p>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel :disabled="firstWillFree">
        <v-expansion-panel-header> A voucher </v-expansion-panel-header>
        <v-expansion-panel-content>
          <RedeemVoucherSubscription
            v-if="paymentPlan == 'SUBSCRIPTION'"
            :payment-plan="paymentPlan"
            @voucher-verified="showVoucherPaymentForm = true"
          />
          <RedeemVoucherOnceOff v-else :payment-plan="paymentPlan" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { TESTATOR_TRANSACTIONS_QUERY } from '../../constants/graphql/payments';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import RecurringPayment from './RecurringPayment.vue';
  import RedeemVoucherOnceOff from './RedeemVoucherOnceOff.vue';
  import RedeemVoucherSubscription from './RedeemVoucherSubscription.vue';
  import PaymentForm from './PaymentForm.vue';
  import RedeemFirstWillFreeOnceOff from './RedeemFirstWillFreeOnceOff.vue';
  import RedeemFirstWillFreeSubscription from './RedeemFirstWillFreeSubscription.vue';

  export default {
    name: 'PaymentAccordion',
    components: {
      RecurringPayment,
      RedeemVoucherOnceOff,
      RedeemVoucherSubscription,
      PaymentForm,
      RedeemFirstWillFreeOnceOff,
      RedeemFirstWillFreeSubscription,
    },
    props: {
      paymentPlan: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        getTransactionStatus: {},
        registrationCards: [],
        paymentFormLoaded: false,
        showVoucherPaymentForm: false,
        testator: {},
        panel: null,
      };
    },
    computed: {
      onceOffPrice() {
        return process.env.VUE_APP_ONCE_OFF_PRICE;
      },
      firstWillFree() {
        return this.testator.isEntitledToFirstWillFree;
      },
    },
    apollo: {
      registrationCards: {
        query: TESTATOR_TRANSACTIONS_QUERY,
        variables() {
          return {
            testatorId: this.testatorId,
          };
        },
        skip() {
          return this.isLoggedInAsSomeoneElse;
        },
      },
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data && response.data.testator) {
            if (this.firstWillFree) {
              this.panel = 0;
            }
            if (this.testator.hasActivePayment) {
              this.$router.push('/overview');
            }
          }
        },
      },
    },
  };
</script>
